/**
 * List Groups — frontend shapes. The rule AST is the shared contract
 * (shared/src/list-groups); everything here mirrors the API rows verbatim.
 * For Media Devoted | Created By Ciro Autiero
 */
import type {
  ListGroupCondition,
  ListGroupMatchCountProgress,
  ListGroupMatchCountsResponse,
  ListGroupRuleNode,
  ListGroupScope,
} from '@trafficpulse/shared';

export type {
  ListGroupCondition,
  ListGroupMatchCountProgress,
  ListGroupMatchCountsResponse,
  ListGroupRuleNode,
  ListGroupScope,
};

/** A group as GET /smswiser/list-groups returns it. `matchCount` is always
 *  null here — counts need tracker stats and arrive separately via the
 *  /match-counts endpoint (useListGroupMatchCounts). */
export interface ListGroup {
  id: string;
  countryKey: string;
  name: string;
  color: string;
  ruleJson: ListGroupRuleNode;
  scope: ListGroupScope;
  ownerContainerId: string | null;
  matchCount: number | null;
  usedBy: Array<{ id: string; name: string; color: string }>;
  createdAt: string;
  updatedAt: string;
}

export interface ListGroupResolveRow {
  wiserId: number;
  name: string | null;
  wiserUid: string | null;
  leadCount: number | null;
  matchedBy: ListGroupRuleNode[];
}

export interface ListGroupResolve {
  count: number;
  totalLists: number;
  lists: ListGroupResolveRow[];
}

/** The builder always emits a flat ALL/ANY group of leaf conditions. */
export interface FlatListGroupRule {
  type: 'and' | 'or';
  nodes: ListGroupCondition[];
}

export interface CreateListGroupInput {
  countryKey: string;
  name: string;
  color?: string;
  ruleJson: ListGroupRuleNode;
  scope?: ListGroupScope;
}

export interface UpdateListGroupInput {
  name?: string;
  color?: string;
  ruleJson?: ListGroupRuleNode;
  scope?: ListGroupScope;
}

export const LIST_GROUP_DEFAULT_COLOR = '#6366f1';

export const LIST_GROUP_COLOR_PRESETS = [
  '#6366f1',
  '#8b5cf6',
  '#ec4899',
  '#f59e0b',
  '#14b8a6',
  '#0ea5e9',
  '#16a34a',
  '#64748b',
] as const;
